export default __webpack_public_path__ + "static/media/mandalore-webfont.7ee77e2b.woff";